// handle border collapse
function compactItemBorder(token, borderedItemCls, popoverFocusedCls) {
    const childCombinator = borderedItemCls ? '> *' : '';
    return {
        '&-item:not(&-last-item)': {
            marginInlineEnd: -token.lineWidth,
        },
        '&-item': Object.assign(Object.assign({ [`&:hover ${childCombinator}, &:focus ${childCombinator}, &:active ${childCombinator}`]: {
                zIndex: 2,
            } }, (popoverFocusedCls
            ? {
                [`&${popoverFocusedCls}`]: {
                    zIndex: 2,
                },
            }
            : {})), { [`&[disabled] ${childCombinator}`]: {
                zIndex: 0,
            } }),
    };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, borderedElementCls) {
    const childCombinator = borderedElementCls ? `> ${borderedElementCls}` : '';
    return {
        [`&-item:not(&-first-item):not(&-last-item) ${childCombinator}`]: {
            borderRadius: 0,
        },
        '&-item:not(&-last-item)&-first-item': {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
            },
        },
        '&-item:not(&-first-item)&-last-item': {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0,
            },
        },
    };
}
export function genCompactItemStyle(token, prefixCls, 
/** Some component borders are implemented on child elements like `Select` */
borderedElementCls, 
/**
 * Some components have special `focus` className especially with popovers like `Select` and
 * `DatePicker`
 */
popoverFocusedCls) {
    return {
        '&-compact': Object.assign(Object.assign({}, compactItemBorder(token, borderedElementCls, popoverFocusedCls)), compactItemBorderRadius(prefixCls, borderedElementCls)),
    };
}
